import React, { useState, useEffect } from 'react';
import { Alert, Typography, Button, Col, Spin } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useLocation, useHistory } from 'react-router-dom';
import { APPLEPIE_API_ROOT } from '../../constants';
import './ConfirmEmail.less';

const ConfirmEmail = () => {
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [errorMessage, setErrorMessage] = useState('');
    const { Title } = Typography;
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');

        if (!token) {
            setStatus('error');
            setErrorMessage('確認トークンが見つかりません。');
            return;
        }

        // Call API to confirm email
        fetch(`${APPLEPIE_API_ROOT}/confirm`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setStatus('success');
                } else {
                    setStatus('error');
                    setErrorMessage(data.errors?.join(', ') || '確認に失敗しました。');
                }
            })
            .catch(() => {
                setStatus('error');
                setErrorMessage('サーバーとの通信に失敗しました。');
            });
    }, [location.search]);

    const goToLogin = () => {
        history.push('/login');
    };

    return (
        <div className='confirm-layout'>
            <Col span={6} className='confirm-wrapper'>
                {status === 'loading' && (
                    <>
                        <Spin size="large" />
                        <Title level={4} style={{ marginTop: 16 }}>メールアドレスを確認中...</Title>
                    </>
                )}

                {status === 'success' && (
                    <>
                        <CheckCircleOutlined style={{ fontSize: 48, color: '#52c41a' }} />
                        <Title level={4} style={{ marginTop: 16 }}>メールアドレスが確認されました</Title>
                        <Alert
                            message="確認完了"
                            description="アカウントが有効になりました。ログインしてください。"
                            type="success"
                            showIcon
                            style={{ marginBottom: 16 }}
                        />
                        <Button type="primary" block onClick={goToLogin}>
                            ログインページへ
                        </Button>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <CloseCircleOutlined style={{ fontSize: 48, color: '#ff4d4f' }} />
                        <Title level={4} style={{ marginTop: 16 }}>確認に失敗しました</Title>
                        <Alert
                            message="エラー"
                            description={errorMessage}
                            type="error"
                            showIcon
                            style={{ marginBottom: 16 }}
                        />
                        <Button type="primary" block onClick={goToLogin}>
                            ログインページへ
                        </Button>
                    </>
                )}
            </Col>
        </div>
    );
};

export default ConfirmEmail;

